export default class PermissionConstants {
  /* Permisos de Tablero de Control */
  static DASHBOARD = "DASHBOARD";
}
